module.exports = __webpack_public_path__ + "static/media/noData.cb61ac4f.svg";